import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isNosotros = location.pathname === '/nosotros';
  const isProyectos = location.pathname === '/proyectos';
  const isContacto = location.pathname === '/contacto';
  const isNotFound = location.pathname !== '/' && location.pathname !== '/nosotros' && location.pathname !== '/proyectos' && location.pathname !== '/contacto';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isHome || isNosotros || isProyectos || isContacto || isNotFound ? 'header-overlay' : ''}`}>
      <div className="header-left">
        <Link to="/" className="header-logo-link" onClick={closeMenu}>
          <img 
            src="/images/Solectric_header.png" 
            alt="Solectric Group Logo" 
            className="header-logo"
          />
        </Link>
        <button 
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <img 
            src="/images/menu_phone.svg" 
            alt="Menu" 
            className="menu-icon"
          />
        </button>
      </div>
      <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
        <button 
          className="nav-close-button"
          onClick={closeMenu}
          aria-label="Close menu"
        >
          ×
        </button>
        <Link to="/nosotros" className="nav-link" onClick={closeMenu}>Nosotros</Link>
        <Link to="/proyectos" className="nav-link" onClick={closeMenu}>Proyectos</Link>
        <Link to="/contacto" className="nav-link" onClick={closeMenu}>Contacto</Link>
      </nav>
    </header>
  );
};

export default Header;

